import { Platform, StyleSheet } from 'react-native';

import { Theme } from '@constants';

import { DEBUG } from '../../helpers/Platform';

export const styles = StyleSheet.create({
  exitNode: {
    height: 10,
    left: 0,
    opacity: 1,
    position: 'absolute',
    right: 0,
    top: 0,
    width: Theme.px(1920),
  },
  icon: {
    marginTop: Theme.px(8),
    paddingBottom: Theme.px(8),
  },
  image: {
    color: Theme.whisperWhite,
    height: Theme.px(32),
    resizeMode: 'contain',
    width: Theme.px(32),
  },
  menu: {
    elevation: 500,
    height: Theme.px(540),
    position: 'absolute',
    zIndex: 500,
  },
  menuItem: {
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: Theme.px(72),
    marginTop: Theme.px(60),
    opacity: 0.63,
    ...Platform.select({
      web: {
        outlineWidth: 0,
      },
    }),
  },
  menuItemCurrent: {
    opacity: 1,
  },
  xfinityLogo: {
    alignItems: 'flex-end',
    height: Theme.px(50),
    justifyContent: 'flex-end',
    marginLeft: DEBUG ? Theme.px(800) : Theme.px(950),
    marginRight: Theme.px(72),
    marginTop: Theme.px(60),
    width: Theme.px(100),
    ...Platform.select({
      web: {
        outlineWidth: 0,
      },
    }),
  },
});
